import * as React from 'react';
import axios from 'axios';
import axiosInstance from '../../utils/axiosInstance.js'
import qs, { parse } from 'qs'
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import {NestedMenuItem} from 'mui-nested-menu';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import AddLinkIcon from '@mui/icons-material/AddLink';

import { setShowMapMenu, setBoothFileList } from '../../actions/main.js';

import { setBoothHistory } from '../../actions/booth_history.js';

import { connect } from 'react-redux';

import { v4 as uuidv4 } from 'uuid';
import { API_URL, S3_URL, ESHOW_URL } from '../../config.js'

function MapMenu(props) {

  const [boothMapList, setBoothMapist] = React.useState([]);

  var groupOptions = props.main.groupOptions;
  var boothFileList = props.main.boothFileList;
  
  React.useEffect(() => {
      for(var i = 0; i <boothFileList.length; i++){
            
          let mapJs = boothFileList[i]['MAPJS'];
          if(mapJs && mapJs != ''){
            try{
              mapJs = JSON.parse(mapJs);
            }
            catch(e){
    
            }
            if(!mapJs.overview){              
              boothMapList.push(boothFileList[i]);
            }
          }
        }
  }, []);

  const handleClickedAssign = (event, booth_key_id) => {
    let target_id = props.main.showMapMenu.targetId;

    props.onSetMapLink(target_id, booth_key_id);
    
    props.setShowMapMenu({...props.main.showMapMenu, open:false});
  };

  const handleClickedRelease = (event) => {
    
    // props.setBoothHistory({ content: (props.main.mainCanvas.toDatalessObject()), action:{type:'hold', objects:objects}})
  };
  
  
  const handleClickedBackward= (event) => {
    
  };  
  const handleClickedGroup= (event) => {
    
  };
  
  var targetId= false; // props.main.showMapMenu.targetId
  var isTable = false
  var combineable = false
  var assignable = false
  var unassignable = false
  

  if(targetId){

  }
  else{

  }

  return (
    <>  
      {props.main.showMapMenu.open&&
      <Popover
          // id={id}
          sx={{zIndex:10006}}
          open={props.main.showMapMenu.open?props.main.showMapMenu.open:false}
          // anchorEl={anchorEl}
          onClose={()=>props.setShowMapMenu(false)}
          anchorPosition={{ top: (props.main.showMapMenu.top?props.main.showMapMenu.top:0), left: (props.main.showMapMenu.left?props.main.showMapMenu.left:0) }}
          anchorReference={'anchorPosition'}
        >
        {boothMapList.map((boothFile) => (
          <MenuList>
            {(boothFile.TITLE != "Overview") && 
            <MenuItem onClick={(event)=>handleClickedAssign(event, boothFile.KEY_ID)}>
              <ListItemIcon>
                <AddLinkIcon fontSize="small"/>
              </ListItemIcon>
              <ListItemText>{boothFile.TITLE}</ListItemText>
            </MenuItem>
            }
          </MenuList>
        ))}

      </Popover>
      }
      
    </>
  );
}

const mapStateToProps = (state) => {
    return {
      main: state.main,
      element: state.element,
      ui: state.ui,
    };
  };
  
  const mapDispatchProps = (dispatch) => {
    return {   
      setShowMapMenu:  data=>dispatch(setShowMapMenu(data)),
      setBoothFileList: data=>dispatch(setBoothFileList(data)),
      setBoothHistory: data=>dispatch(setBoothHistory(data)),      
    };
  };
  
export default connect(mapStateToProps, mapDispatchProps)(MapMenu);